import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import Dialog from 'next/javascripts/components/dialog';
import 'next/stylesheets/components/projects/todo-field-dialog.scss';

Component('tr-project-todo-field-dialog', {
  extends: [Dialog],

  mixins: [eventListenerMixin],

  ready() {
    this.listenTo(
      this.querySelector('tr-tabs'),
      'tr-tabs:activated',
      this.activateTabPane.bind(this),
    );
  },

  activateTabPane(event) {
    const { tab } = event.detail;

    [...this.querySelectorAll('.tab-content .tab-pane')].forEach((pane) => {
      pane.classList.toggle('hide', tab.dataset.name !== pane.dataset.tab);
    });
  },

  disconnected() {
    this.stopListening();
  },
});
